import HotDesktopNavigation from './DesktopNavigation/DesktopNavigation.vue'
import HotAuthActions from './AuthActions/AuthActions.vue'
import HotMobileActions from './MobileActions/MobileActions.vue'
import HotMobileNavigation from './MobileNavigation/MobileNavigation.vue'

export default {
  components: {
    HotDesktopNavigation,
    HotAuthActions,
    HotMobileActions,
    HotMobileNavigation,
  },
  props: {
    notificationBar: {
      type: Object,
    },
    navigation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
      mobileMenuOpen: false,
      activeDropdown: null,
      authDropdownOpen: false,
      mobileAccordionStates: {},
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    window.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 992
    },
    toggleDropdown(index) {
      if (this.activeDropdown === index) {
        this.activeDropdown = null
      } else {
        this.activeDropdown = index
      }
    },
    toggleAuthDropdown() {
      this.authDropdownOpen = !this.authDropdownOpen
    },
    openMobileMenu() {
      this.mobileMenuOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
    },
    toggleMobileAccordion(index) {
      this.$set(
        this.mobileAccordionStates,
        index,
        !this.mobileAccordionStates[index]
      )
    },
    getAccordionStyle(index) {
      return {
        maxHeight: this.mobileAccordionStates[index]
          ? this.$el.querySelectorAll('.mobile-accordion-content')[index]
              .scrollHeight + 'px'
          : '0',
        padding: this.mobileAccordionStates[index] ? '1.5rem 0 1.5rem 0' : '0',
      }
    },
    handleOutsideClick(event) {
      // Close dropdowns if clicked outside
      if (
        !event.target.closest('.dropdown') &&
        !event.target.closest('.mobile-menu')
      ) {
        this.activeDropdown = null
        this.authDropdownOpen = false
      }
    },
  },
}
